import { useEffect } from "react";

export const option = {
    key: "rzp_test_ZMfftfywEkzFy7",
    currency: "INR",
    name: "Creaxt Innovation Private LTD",
    description: "Creaxt payment gateway powered by razorpay",
    image: "https://mues-solution.s3.ap-south-1.amazonaws.com/png/mues_logo_3d.png",
    // prefill: {
    //     name: "sameer Mohanty",
    //     email: "sameer.mohanty@creaxt.com",
    //     contact: "7888033249",
    // },
    notes: {
        address: "Creaxt Innovation Private LTD",
    },
    theme: {
        color: "#2884FF",
        fontFamily: "'Poppins', sans-serif",
    },
}

// Helper function to debounce API calls
export const debounce = (func, wait) =>{
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
}

// helper function to create unique code
export const generateUniqueCode = () => {
    // Helper function to generate a random string of letters
    const generateLetters = (length) => {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += letters.charAt(Math.floor(Math.random() * letters.length));
        }
        return result;
    };

    // Helper function to generate a random string of numbers
    const generateNumbers = (length) => {
        const numbers = '0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += numbers.charAt(Math.floor(Math.random() * numbers.length));
        }
        return result;
    };

    // Generate the code in the format ATQP-1231-PPMK-0927
    const part1 = generateLetters(4);
    const part2 = generateNumbers(4);
    const part3 = generateLetters(4);
    const part4 = generateNumbers(4);

    return `${part1}-${part2}-${part3}-${part4}`;
}

// helper function to group by date
export const groupByDate = (array) => {
    const groupedDate = array?.reduce((group, message) => {
        // Use a Date object to get the formatted date
        const date = new Date(message.created_on).toISOString().split('T')[0];

        // Check if there is already an entry for this date
        const existingDateGroup = group.find(item => item.date === date);

        if (existingDateGroup) {
            // If the date already exists, push the message to the existing group
            existingDateGroup.messages.push(message);
        } else {
            // If the date does not exist, create a new group
            group.push({
                date: date,
                messages: [message]
            });
        }

        return group;
    }, []);

    return groupedDate;
};


export const useClickOutside =(ref, callback)=>{
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}

  

